import gsap, { Expo, Power2, Power4 } from 'gsap';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
// import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import { GetBy } from '../_app/cuchillo/core/Element';
import { isTouch } from '../_app/cuchillo/core/Basics';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { SplitText } from 'gsap/all';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Maths } from '../_app/cuchillo/utils/Maths';

const INTERVAL = 4000;

class ScrollItem__DefaultText extends Scroll_Item {

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
        
        this.timeline = gsap.timeline({ paused: true });
        this.isAnimated = false;
        
        if(this.item.classList.contains("body")) {
            this.delay = .4;
            this.setupBodyShow(__link);
        } else if(this.item.classList.contains("upper-text")) {
            this.delay = 0;
            this.setupUpperShow(__link);
        } else {
            this.delay = 0;
            this.setupTitleShow(__link);
        }
       // [...GetBy.class("__titleShow", __link)].map(dom => this.setupTitleShow(dom));
       // [...GetBy.class("__textShow", __link)].map(dom => this.setupShowText(dom));
       // this.delay = 0;
       // [...GetBy.class("__textScale", __link)].map(dom => this.setupScaleText(dom));

       

        this.onShow = () => {
            if(!this.isAnimated) this.showCb();
            this.isAnimated = true;
        };
        this.onHide = () => {

        };
        this.onMove = () => { };
    }

    setupTitleShow(dom) {
        const text = new SplitText(dom, {
            type: 'words',
            wordsClass: 'word-child'
        }).words;

        let delay = this.delay;
        text.map(dom => {
            this.timeline.from(dom, {
                opacity: 0,
                duration: .1,
                ease: Power2.easeOut
            }, delay + .25);
            this.timeline.from(dom, {
                y: "100%",
                duration: .6,
                rotate: 10,
                force3D: true,
                ease: Power2.easeOut
            }, delay);

            delay += 0.08;
        });
    }

    setupUpperShow(dom) {
        const text = new SplitText(dom, {
            type: 'words',
            wordsClass: 'word-child'
        }).words;

        let delay = this.delay;
        text.map(dom => {
            this.timeline.from(dom, {
                opacity: 0,
                duration: .2,
                ease: Power2.easeOut
            }, delay);
            
            delay += 0.04;
        });
    }

    setupBodyShow(dom) {
        const text = new SplitText(dom, {
            type: 'lines',
        }).lines;

        let delay = this.delay;
        text.map(dom => {
            this.timeline.from(dom, {
                opacity: 0,
                duration: .4,
                ease: Power2.easeOut
            }, delay);
           
            delay += 0.08;
        });
    }

    setupScaleText(dom) {
        const text = new SplitText(dom, {
            type: 'words',
            wordsClass: 'word-child'
        }).words;

        let delay = this.delay;
        Functions.arrayRandom(text).map(dom => {
            this.timeline.from(dom, {
                alpha: 0,
                duration: .01,
                force3D: true,
                ease: Power2.easeIn
            }, delay);

            this.timeline.from(dom, {
                scaleX: 3,
                scaleY: 3,
                duration: .3,
                force3D: true,
                ease: Expo.easeIn
            }, delay);

            delay += 0.1;
        });

        this.delay += .5;
    }

    setupShowText(dom) {
        const text = new SplitText(dom, {
            type: 'words',
            wordsClass: 'word-child'
        }).words;

        let delay = this.delay;
        let time = .1;
        text.map(dom => {
            this.timeline.from(dom, {
                alpha: 0,
                duration: .4 + time,
                force3D: true,
                ease: Power2.easeOut
            }, delay);

            time += 0.12;
            delay += 0.03;
        });

        this.delay += .5;
    }

    showCb() {
        this.timeline.restart();
    }
}

Scroll._registerClass('DefaultText', ScrollItem__DefaultText);

export default ScrollItem__DefaultText;
